import { render, staticRenderFns } from "./WorkoutSchedule.vue?vue&type=template&id=154fb04d&scoped=true"
import script from "./WorkoutSchedule.vue?vue&type=script&lang=js"
export * from "./WorkoutSchedule.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSchedule.vue?vue&type=style&index=0&id=154fb04d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154fb04d",
  null
  
)

export default component.exports